import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { AUDIENCES } from "@/lib/platform";

export default function Audience() {
  const [open, setOpen] = useState(0);

  return (
    <section data-testid="audience-section" className="relative bg-[#0B1F3D] text-[#F5EBD9] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.9 }}
          className="mb-14 lg:mb-20"
        >
          <div className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#F5892E] mb-4 flex items-center gap-4">
            <span className="h-px w-10 bg-[#F5892E]" />
            Кой идва на събитията ни
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-7xl leading-[0.95] tracking-tight max-w-5xl">
            Не е нужно да си инвеститор.<br />
            <span className="text-[#F5892E]">Нужно е да искаш да разбираш пазара.</span>
          </h2>
        </motion.div>

        <div className="border-t border-[#1E3A63]">
          {AUDIENCES.map((a, i) => (
            <motion.div
              key={a.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.7, delay: i * 0.06 }}
              className="border-b border-[#1E3A63]"
              data-testid={`audience-${i}`}
            >
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`audience-toggle-${i}`}
                className="w-full flex items-center justify-between gap-6 py-6 lg:py-8 text-left group"
              >
                <span className={`font-display uppercase text-2xl sm:text-3xl lg:text-4xl tracking-tight transition-colors duration-300 ${open === i ? "text-[#F5892E]" : "group-hover:text-[#F5892E]"}`}>
                  {a.title}
                </span>
                <span
                  className={`shrink-0 w-11 h-11 rounded-full border flex items-center justify-center transition-all duration-300 ${
                    open === i
                      ? "border-[#F5892E] bg-[#F5892E] text-[#0B1F3D] rotate-45"
                      : "border-[#F5EBD9]/25 text-[#F5EBD9]/60 group-hover:border-[#F5892E] group-hover:text-[#F5892E]"
                  }`}
                >
                  <Plus className="w-5 h-5" strokeWidth={2.2} />
                </span>
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.45, ease: [0.2, 0.8, 0.2, 1] }}
                    className="overflow-hidden"
                  >
                    <p className="pb-7 lg:pb-9 max-w-[60ch] text-[#C8D4E6] text-base lg:text-lg leading-relaxed">
                      {a.text}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
